import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";

const emptyForm = {
  mode: "CREATE_STUDENT",
  id: null,
  studentId: null,

  // student info
  name: "",
  email: "",
  mobile: "",
  gender: "",
  dob: "",

  // measurement
  height: "",
  weight: "",
  heartRate: ""
};

const AddEditMeasurementDialog = ({
  open,
  editData,
  onClose,
  onSave
}: {
  open: boolean;
  editData?: any;
  onClose: () => void;
  onSave: (data: any) => void;
}) => {
  const [form, setForm] = useState<any>(emptyForm);

  // mode helpers
  const isCreateStudent = form.mode === "CREATE_STUDENT";
  const isEdit = form.mode === "EDIT";
  const isAddMeasurement = form.mode === "ADD_MEASUREMENT";

 useEffect(() => {
  if (!open) return;

  if (editData) {
    setForm({
      ...emptyForm,
      ...editData,
      dob: editData.dob
        ? editData.dob.substring(0, 10) // ✅ FIX
        : "",
      mode: editData.mode ?? "EDIT"
    });
  } else {
    setForm(emptyForm);
  }
}, [editData, open]);


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((prev: any) => ({
      ...prev,
      [name]: value
    }));
  };

 const handleSaveClick = () => {
  onSave({
    mode: form.mode, // ✅ FIXED

    id: form.id,
    studentId: form.studentId,

    name: form.name,
    email: form.email,
    mobile: form.mobile,
    gender: form.gender,
    dob: form.dob,

    height: Number(form.height),
    weight: Number(form.weight),
    heartRate: Number(form.heartRate)
  });
};


  const getTitle = () => {
    if (isCreateStudent) return "Add Student & Measurement";
    if (isEdit) return "Edit Student & Measurement";
    return "Add New Measurement";
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle component="div" sx={{ fontWeight: 600, color: "#1F497D" }}>
        {getTitle()}
      </DialogTitle>

      <DialogContent>
        <Stack spacing={2} mt={2}>

          {/* STUDENT INFO */}
          <TextField
            name="name"
            label="Name"
            value={form.name}
            onChange={handleChange}
            disabled={isAddMeasurement}
            fullWidth
          />

          <TextField
            name="email"
            label="Email"
            value={form.email}
            onChange={handleChange}
            disabled={isAddMeasurement}
            fullWidth
          />

          <TextField
            name="mobile"
            label="Mobile"
            value={form.mobile}
            onChange={handleChange}
            disabled={isAddMeasurement}
            fullWidth
          />

          {/* ✅ GENDER DROPDOWN */}
          <FormControl fullWidth disabled={isAddMeasurement}>
            <InputLabel id="gender-label">Gender</InputLabel>
            <Select
              labelId="gender-label"
              label="Gender"
              name="gender"
              value={form.gender}
              onChange={(e) =>
                setForm((prev: any) => ({
                  ...prev,
                  gender: e.target.value
                }))
              }
            >
              <MenuItem value="Male">Male</MenuItem>
              <MenuItem value="Female">Female</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </Select>
          </FormControl>

          <TextField
            name="dob"
            label="DOB"
            type="date"
            value={form.dob}
            onChange={handleChange}
            disabled={isAddMeasurement}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />

          {/* MEASUREMENTS */}
          <TextField
            name="height"
            label="Height (cm)"
            type="number"
            value={form.height}
            onChange={handleChange}
            fullWidth
          />

          <TextField
            name="weight"
            label="Weight (kg)"
            type="number"
            value={form.weight}
            onChange={handleChange}
            fullWidth
          />

          <TextField
            name="heartRate"
            label="Heart Rate (bpm)"
            type="number"
            value={form.heartRate}
            onChange={handleChange}
            fullWidth
          />

          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button variant="outlined" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleSaveClick}>
              Save
            </Button>
          </Stack>

        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default AddEditMeasurementDialog;
